/**
 * Reishore Color Gallery Filter — DEBUG BUILD
 */
(function () {
  'use strict';

  if (!window.location.pathname.includes('/products/')) return;

  let variantColorMap = null;
  let currentColor = null;

  async function loadVariantMap() {
    const handle = window.location.pathname.match(/\/products\/([^/?#]+)/)?.[1];
    if (!handle) return;
    try {
      const res = await fetch(`/products/${handle}.js`);
      const product = await res.json();
      console.log('[reishore] product.options:', product.options);
      const colorIdx = product.options.findIndex((o) => (o.name || o).toLowerCase() === 'color');
      console.log('[reishore] colorIdx:', colorIdx);
      if (colorIdx === -1) return;
      variantColorMap = {};
      for (const v of product.variants) {
        variantColorMap[v.id] = v[`option${colorIdx + 1}`];
      }
      console.log('[reishore] variantColorMap entries:', Object.keys(variantColorMap).length);
    } catch (e) {
      console.error('[reishore] loadVariantMap error:', e);
    }
  }

  function filterGallery(color) {
    if (!color) { console.warn('[reishore] filterGallery called with no color'); return; }
    currentColor = color;
    console.log('[reishore] filterGallery:', color);

    // --- Slides ---
    const slides = Array.from(document.querySelectorAll('media-gallery slideshow-slide'));
    console.log('[reishore] slides found:', slides.length);
    slides.forEach((slide) => {
      const img = slide.querySelector('img');
      if (!img || !img.alt) { slide.style.display = ''; return; }
      slide.style.display = img.alt.includes(color) ? '' : 'none';
    });

    // --- Thumbnails ---
    const thumbs = Array.from(document.querySelectorAll('slideshow-controls .slideshow-controls__thumbnail'));
    console.log('[reishore] thumbnails found:', thumbs.length);
    thumbs.forEach((btn, i) => {
      const img = btn.querySelector('img');
      const alt = img?.alt || '';
      const matches = alt.includes(color);
      if (i < 3) console.log(`[reishore] thumb[${i}] alt="${alt}" matches=${matches}`);
      btn.style.display = matches || !alt ? '' : 'none';
    });
  }

  function colorForVariant(id) {
    return variantColorMap?.[id] ?? null;
  }

  function colorFromUrl() {
    const id = parseInt(new URLSearchParams(window.location.search).get('variant'));
    const color = id ? colorForVariant(id) : null;
    console.log('[reishore] colorFromUrl id:', id, '→', color);
    return color;
  }

  function firstColor() {
    const c = variantColorMap ? Object.values(variantColorMap)[0] ?? null : null;
    console.log('[reishore] firstColor:', c);
    return c;
  }

  function setupObserver() {
    const section = document.querySelector('media-gallery')?.closest('.shopify-section');
    if (!section) { console.warn('[reishore] no section found'); return; }
    let debounce = null;
    const observer = new MutationObserver(() => {
      clearTimeout(debounce);
      debounce = setTimeout(() => {
        if (currentColor) { console.log('[reishore] MutationObserver re-filter'); filterGallery(currentColor); }
      }, 50);
    });
    observer.observe(section, { childList: true, subtree: true });
    console.log('[reishore] observer set on section');
  }

  async function init() {
    console.log('[reishore] init start');
    await loadVariantMap();
    const color = colorFromUrl() || firstColor();
    console.log('[reishore] initial color:', color);

    filterGallery(color);
    setTimeout(() => filterGallery(currentColor), 300);
    setTimeout(() => filterGallery(currentColor), 800);

    setupObserver();

    document.addEventListener('variant:update', (e) => {
      const variantId = e.detail?.resource?.id;
      const color = variantId ? colorForVariant(variantId) : null;
      console.log('[reishore] variant:update', variantId, '→', color);
      if (color) {
        currentColor = color;
        setTimeout(() => filterGallery(color), 100);
        setTimeout(() => filterGallery(color), 400);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
